import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cloudAuditHero from "../assets/Hero/cloud-audit-hero.jpg"; // Replace with your hero image
import cloudAuditImage from "../assets/Hero/cloud-infrastructure-audit.png"; // Replace with your cloud audit image
import "../assets/css/cloudInfrastructureAuditPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const cloudAuditData = {
  hero: {
    title: "Cloud Infrastructure Audit",
    subtitle: "Ensure Optimal Performance and Security for Your Cloud Environment",
  },
  introduction: {
    heading: "Why Cloud Infrastructure Audit Matters",
    paragraphs: [
      "A cloud infrastructure audit is essential for identifying vulnerabilities, optimizing performance, and ensuring compliance with industry standards.",
      "Our cloud audit solutions are designed to provide comprehensive assessments, actionable recommendations, and enhanced security for your cloud environment.",
    ],
  },
  cta: {
    heading: "Ready to Audit Your Cloud Infrastructure?",
    text: "Contact us today to learn more about our Cloud Infrastructure Audit Solutions and how we can help your business thrive.",
  },
};

export const CloudInfrastructureAuditPage = ({ data }) => {
  const cloudAuditRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = cloudAuditRef.current.querySelectorAll(".cloud-audit-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: cloudAuditRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="cloud-audit-page" ref={cloudAuditRef}>
      {/* Hero Section */}
      <div
        className="cloud-audit-hero-section"
        style={{ backgroundImage: `url(${cloudAuditHero})` }}
      >
        <h1 className="cloud-audit-animate">{cloudAuditData.hero.title}</h1>
        <p className="cloud-audit-animate">{cloudAuditData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container cloud-audit-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="cloud-audit-animate">{cloudAuditData.introduction.heading}</h2>
            {cloudAuditData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="cloud-audit-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 cloud-audit-image-container">
            <img
              src={cloudAuditImage}
              className="img-fluid cloud-audit-animate"
              alt="Cloud Infrastructure Audit"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="container cloud-audit-cta">
        <h2 className="cloud-audit-animate">{cloudAuditData.cta.heading}</h2>
        <p className="cloud-audit-animate">{cloudAuditData.cta.text}</p>
        <button
          className="btn btn-primary cloud-audit-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};